"use client";

import { useInfiniteQuery } from "@tanstack/react-query";
import {
  listUserReplies,
  type UserRepliesCursor,
} from "@/actions/user-replies";
import { profileTabKeys } from "@/lib/query-keys/profile-tabs";

/** A person's replies, newest first, for the profile's Posts & replies tab. */
export function useUserReplies(
  userId: string,
  options?: { enabled?: boolean },
) {
  return useInfiniteQuery({
    queryKey: profileTabKeys.userReplies(userId),
    enabled: options?.enabled ?? true,
    initialPageParam: null as UserRepliesCursor | null,
    queryFn: async ({ pageParam }) => {
      const result = await listUserReplies({ userId, cursor: pageParam });
      if (!result.ok) throw new Error(result.message);
      return result.data;
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    staleTime: 15_000,
  });
}
